import type { CartResponseResponse } from '../../../model/cart/cart';
import { productSizeAndPackTextConverter } from '../../../utils/product';
import type { CheckoutContext } from './types';

const buildVariant = (itemData: CartResponseResponse['cart']['item'][number]['itemData']): string | undefined => {
  return productSizeAndPackTextConverter(itemData ?? {}) ?? undefined;
};

export const createCheckoutContextFromCartResponse = (cartResponse: CartResponseResponse): CheckoutContext => {
  const cartProducts = cartResponse.cart.item.map((item) => ({
    id: item.productId.toString(),
    quantity: item.quantity,
    variant: buildVariant(item.itemData),
    productUrl: item.productLink || undefined,
  }));

  return {
    totalItems: cartProducts.length,
    totalQuantity: cartProducts.reduce((total, item) => total + (item.quantity ?? 0), 0),
    total: cartResponse.cart.totals.total,
    subtotal: cartResponse.cart.totals.totalPrice,
    discount: cartResponse.cart.totals.totalDiscount,
    currency: cartResponse.cart.currency.currency,
    cartProducts,
  };
};
